import { useEffect, useState } from 'react';

import { getSelectedOffers } from '../api/getSelectedOffers';
import { Offers } from '../types/OfferTypes';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

/**
 * Runs the service for get offers
 * @returns the states for available offers, selected offers, set selected offers and is error
 */
const useGetOfferService = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    const [availableOffers, setAvailableOffers] = useState<Offers>();
    const [selected, setSelected] = useState<string | undefined>(undefined);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsError(false);
        if (!applicationReferenceNumber) {
            return;
        }
        getSelectedOffers(proxyBaseUrl, apiKey, applicationReferenceNumber, authenticationData)
            .then((offers) => {
                setAvailableOffers(offers);
                if (offers && offers?.offers?.length > 0) {
                    setSelected(offers.offers[0].offerId);
                }
            })
            .catch(() => {
                setIsError(true);
            });
    }, [applicationReferenceNumber]);

    return { availableOffers, selected, setSelected, isError };
};
export default useGetOfferService;
